'use strict';

function QuoteResultModelFactory(MODULE_INFO) {
	function newQuoteResultModel(response) {
		switch (MODULE_INFO.id) {
			case 'vehicle':
				return new VehicleQuoteResultModel(response);
			case 'bike':
				return new BikeQuoteResultModel(response);
			case 'caravan':
				return new CaravanQuoteResultModel(response);
			case 'home':
				return new HomeQuoteResultModel(response);
			default:
				throw 'Unknown module info';
		}
	}

	return {
		newQuoteResultModel: newQuoteResultModel
	}
}
